<template>
  <b-overlay :show="loading" class="row">
    <div class="col-12 col-lg-8 c g">
      <div class="card">
        <div class="card-header">
          <h4>إعدادات الإرسال</h4>
        </div>
        <div class="card-body">

          <h5 class="mb-2">الوقت بين كل رسالة وأخرى (بالثواني)</h5>
          <p class="text-muted">
            يتم اختيار وقت عشوائي بين أقل وأعلى قيمة لكل رسالة. كلما كانت القيم أكبر،
            كان الإرسال أبطأ ولكن أكثر أماناً ضد حظر الواتساب.
          </p>

          <div class="row">
            <div class="form-group col-6">
              <label>أقل وقت (ثانية)</label>
              <input
                type="number"
                min="1"
                max="600"
                class="form-control text-center"
                v-model.number="settings.min_delay"
              />
            </div>
            <div class="form-group col-6">
              <label>أعلى وقت (ثانية)</label>
              <input
                type="number"
                min="1"
                max="600"
                class="form-control text-center"
                v-model.number="settings.max_delay"
              />
            </div>
          </div>

          <hr />

          <h5 class="mb-2">الوضع البطيء (للأجهزة في أول أسبوع)</h5>
          <p class="text-muted">
            يستخدم هذا الإعداد عند تفعيل الوضع البطيء على الجهاز (مثلاً في أول أسبوع
            من إضافته أو عند تفعيله يدوياً).
          </p>

          <div class="row">
            <div class="form-group col-6">
              <label>أقل وقت بطيء (ثانية)</label>
              <input
                type="number"
                min="1"
                max="600"
                class="form-control text-center"
                v-model.number="settings.slow_min_delay"
              />
            </div>
            <div class="form-group col-6">
              <label>أعلى وقت بطيء (ثانية)</label>
              <input
                type="number"
                min="1"
                max="600"
                class="form-control text-center"
                v-model.number="settings.slow_max_delay"
              />
            </div>
          </div>

          <hr />

          <h5 class="mb-2">الرسائل المعلقة عند تغيير الجهاز</h5>
          <div class="form-check">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="settings.auto_reassign_on_new_device"
              />
              عند حذف جهاز وإضافة جهاز جديد، يتم نقل الرسائل المعلقة تلقائياً للجهاز الجديد
            </label>
          </div>
          <small class="text-muted d-block g">
            إذا لم يتم تفعيل الخيار ستبقى الرسائل المعلقة مرتبطة بالجهاز القديم ولن يتم إرسالها.
          </small>

          <hr />

          <div class="col-12 text-center g">
            <button class="btn btn-success" @click="save()" :disabled="saving">
              <i class="fa fa-save"></i>
              {{ saving ? "جاري الحفظ..." : "حفظ الإعدادات" }}
            </button>
          </div>

        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { BOverlay } from "bootstrap-vue";
export default {
  components: {
    BOverlay,
  },
  data() {
    return {
      loading: true,
      saving: false,
      user: JSON.parse(localStorage.getItem("user")),
      settings: {
        min_delay: 5,
        max_delay: 15,
        slow_min_delay: 30,
        slow_max_delay: 40,
        auto_reassign_on_new_device: true,
      },
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      var g = this;
      $.post(api + "/user/messages/send-settings", {
        jwt: this.user.jwt,
      })
        .then(function (r) {
          if (r.status == 100 && r.response) {
            g.settings = {
              min_delay: r.response.min_delay,
              max_delay: r.response.max_delay,
              slow_min_delay: r.response.slow_min_delay,
              slow_max_delay: r.response.slow_max_delay,
              auto_reassign_on_new_device: !!r.response.auto_reassign_on_new_device,
            };
          }
          g.loading = false;
        })
        .catch(function () {
          g.loading = false;
          g.$toast({
            component: ToastificationContent,
            props: {
              title: "حدثت مشكلة في الاتصال",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
    save() {
      var g = this;

      if (Number(g.settings.max_delay) < Number(g.settings.min_delay)) {
        g.$toast({
          component: ToastificationContent,
          props: {
            title: "أعلى وقت يجب أن يكون أكبر من أو يساوي أقل وقت",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return;
      }
      if (Number(g.settings.slow_max_delay) < Number(g.settings.slow_min_delay)) {
        g.$toast({
          component: ToastificationContent,
          props: {
            title: "أعلى وقت بطيء يجب أن يكون أكبر من أو يساوي أقل وقت بطيء",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return;
      }

      g.saving = true;
      $.post(api + "/user/messages/save-send-settings", {
        jwt: this.user.jwt,
        min_delay: this.settings.min_delay,
        max_delay: this.settings.max_delay,
        slow_min_delay: this.settings.slow_min_delay,
        slow_max_delay: this.settings.slow_max_delay,
        auto_reassign_on_new_device: this.settings.auto_reassign_on_new_device,
      })
        .then(function (r) {
          g.saving = false;
          if (r.status == 100) {
            g.$toast({
              component: ToastificationContent,
              props: {
                title: "تم الحفظ",
                icon: "CheckIcon",
                variant: "success",
              },
            });
          } else {
            g.$toast({
              component: ToastificationContent,
              props: {
                title: r.response || "تعذر الحفظ",
                icon: "EditIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch(function () {
          g.saving = false;
          g.$toast({
            component: ToastificationContent,
            props: {
              title: "حدثت مشكلة في الاتصال",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
  },
};
</script>
